// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__sUjQK","gfeWrapper":"CalendarEvent_gfeWrapper__3ePpz"};